import {DynamicSvgIcon} from "@/agentur/DynamicSvgIcon";

import ProGroupIcon from "@/assets/svgs/Progroup-Superzeichen_RGB_1C_negativ.svg?react";

export const BoxHubZeichen = ({ mode }) => <DynamicSvgIcon name="BoxHub_Zeichen" width={80} height={80} mode={mode} />;
export const BoxHubLogo = ({ mode }) => (
    <DynamicSvgIcon name="BoxHub_Logo" width={160} height={22} mode={mode} viewBox="22 26 160 27" />
);

export const AnmeldebestaetigungIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_grafik_anmeldebestaetigung" width={120} height={120} mode={mode} />
);

export const AbbrechenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_abbrechen" width={30} height={30} mode={mode} />
);

export const AbmeldenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_abmelden" width={30} height={30} mode={mode} />
);

export const AnmeldenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_anmelden" width={30} height={30} mode={mode} />
);

export const AntwortIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_antwort" width={30} height={30} mode={mode} />
);

export const BoxIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_box" width={30} height={30} mode={mode} />;

export const BriefIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_brief" width={30} height={30} mode={mode} />;

export const DruckerIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_drucker" width={30} height={30} mode={mode} />
);

export const ExterneAnfragenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_externeanfragen" width={30} height={30} mode={mode} />
);

export const FrageIcon = ({ mode }) => (
    // color ? (
    //     <Box sx={{ "& path, & rect": { fill: color } }} style={{ display: "inline-block" }}>
    //         <DynamicSvgIcon name="boxhub_icon_frage" width={30} height={30} mode={mode} />
    //     </Box>
    // ) : (
    <DynamicSvgIcon name="boxhub_icon_frage" width={30} height={30} mode={mode} />
);
// );

export const GebaeudeIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_gebaeude" width={30} height={30} mode={mode} />
);

export const HakenIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_haken" width={30} height={30} mode={mode} />;

export const HakenInKreisIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_hakeninkreis" width={30} height={30} mode={mode} />
);

export const HochladenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_hochladen" width={30} height={30} mode={mode} />
);

export const InterneAnfragenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_interneanfragen" width={30} height={30} mode={mode} />
);

export const KalenderIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_kalender" width={30} height={30} mode={mode} />
);

export const KladdeIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_kladde" width={30} height={30} mode={mode} />;

export const KopierenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_kopieren" width={30} height={30} mode={mode} />
);

export const MondIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_mond" width={30} height={30} mode={mode} />;

export const PasswortAendernIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_passwortaendern" width={30} height={30} mode={mode} />
);

export const PersonIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_person" width={30} height={30} mode={mode} />;

export const PersonPlusIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_person_plus" width={30} height={30} mode={mode} />
);

export const PlusIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_plus" width={30} height={30} mode={mode} />;

export const PolygonIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_polygon" width={30} height={30} mode={mode} />
);

export const SchliessenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_schliessen" width={30} height={30} mode={mode} />
);

export const SchlossIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_schloss" width={30} height={30} mode={mode} />
);

export const SonneIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_sonne" width={30} height={30} mode={mode} />;

export const TabelleIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_tabelle" width={30} height={30} mode={mode} />
);

export const TelefonIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_telefon" width={30} height={30} mode={mode} />
);

export const VerlinkungIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_verlinkung" width={30} height={30} mode={mode} />
);

export const WeltkugelIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_weltkugel" width={30} height={30} mode={mode} />
);

export const XIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_x" width={30} height={30} mode={mode} />;

export const ZurueckIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_zurueck" width={30} height={30} mode={mode} />
);

export const AdminConsoleIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_adminconsole" width={30} height={30} mode={mode} />
);

export const DruckbildervorhandenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_druckbildervorhanden" width={30} height={30} mode={mode} />
);

export const EntsperrenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_entsperren" width={30} height={30} mode={mode} />
);

export const InfoFilledIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_info_filled" width={30} height={30} mode={mode} />
);

export const InfoOutlineIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_info_outline" width={30} height={30} mode={mode} />
);

export const LogviewerIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_logviewer" width={30} height={30} mode={mode} />
);

export const PdfIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_pdf" width={30} height={30} mode={mode} />;
export const ImgIcon = ({ mode }) => <DynamicSvgIcon name="boxhub_icon_img" width={30} height={30} mode={mode} />;

export const SperrenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_sperren" width={30} height={30} mode={mode} />
);

export const WiderrufenIcon = ({ mode }) => (
    <DynamicSvgIcon name="boxhub_icon_widerrufen" width={30} height={30} mode={mode} />
);

export const JHHoldingBanner = () => <DynamicSvgIcon name="boxhub_banner_jhholding" width={180} height={52} />;

export const AcademyBanner = () => <DynamicSvgIcon name="boxhub_banner_academy" width={180} height={52} />;

export const LinkedInBanner = () => <DynamicSvgIcon name="boxhub_banner_linkedin" width={52} height={52} />;

export { ProGroupIcon };
